import { SVGIconComponent } from './types';

export const Yes: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-181.000000, -392.000000)" fill="currentColor" fillRule="nonzero">
        <g transform="translate(181.000000, 392.000000)">
          <path
            d="M14.974,29.948 C6.716,29.948 0,23.232 0,14.974 C0,6.716 6.716,0 14.974,0 C23.232,0 29.948,6.716 29.948,14.974 C29.948,23.232 23.232,29.948 14.974,29.948 Z M14.974,2.604 C8.154,2.604 2.604,8.15346667 2.604,14.974 C2.604,21.794 8.15346667,27.344 14.974,27.344 C21.794,27.344 27.344,21.7945333 27.344,14.974 C27.344,8.154 21.7945333,2.604 14.974,2.604 Z"
            id="Shape"
          ></path>
          <path
            d="M10.6773333,22.135466 C10.620042,22.135466 10.5601467,22.1301247 10.5002533,22.1223127 C10.0914,22.0676247 9.73465333,21.8202327 9.53672,21.4608527 L6.67212,16.2525193 C6.32576667,15.6223127 6.55493333,14.8306527 7.18514,14.4843193 C7.81534667,14.137966 8.60700667,14.3671327 8.95334,14.9973393 L10.97154,18.669206 L21.20354,8.20587267 C21.7061467,7.69285267 22.5316733,7.68243267 23.0446733,8.18503933 C23.5576933,8.687646 23.5681133,9.51317267 23.0655067,10.0261727 L11.60684,21.7448393 C11.3620467,21.9948393 11.0261133,22.135466 10.6771733,22.135466 L10.6773333,22.135466 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
